module.exports = __webpack_public_path__ + "images/icon/common_ic_add_block-5420c8ef.svg";